<template>
  <div class="bg-select">
    <div class="bg-mask" @click="option_show = false" v-show="option_show"></div>
    <div class="text" @click="option_show = true" :style="{height: height + 'px', 'line-height': height + 'px'}">{{value || default_text}}</div>
    <div class="options" v-show="option_show">
      <div class="option" v-for="item in options" @click="changeValue(item.value, item.show_txt);">{{item.show_txt}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'BgSelect',
    props: {
      options: Array,
      default_text: String | Number,
      height: {
        type: Number | String,
        default: 40,
      },
    },
    data() {
      return {
        option_show: false,
        value: '',
      }
    },
    methods: {
      changeValue(val, text) {
        this.value = text;
        this.option_show = false;
        this.$emit('bg-select', val);
      }
    }
  }
</script>
<style lang="scss" scoped>
.bg-select{
  width: 200px;
  height: 40px;
  .text{
    border-radius: 4px;
    border: 1px solid #D6D7DC;
    box-sizing: border-box;
    position: relative;
    padding-right: 30px;
    padding-left: 10px;
    color: #666;
    cursor: pointer;
    z-index: 2;
    background: white;
    overflow: hidden;
    &:before{
      position: absolute;
      content: "";
      display: block;
      width: 30px;
      height: 100%;
      top: 0;
      right: 0;
      background: {
        repeat: no-repeat;
        size: 12px 9px;
        image: url("../../static/images/btn_up_table2.png");
        position: center;
      };

    }
  }
  .options{
    border: 1px solid #D6D7DC;
    max-height: 200px;
    overflow-y: auto;
    background: white;
    width: 100%;
    position: relative;
    z-index: 2;
    border-radius: 4px;
    .option{
      line-height: 40px;
      padding-left: 10px;
      color: #666;
      cursor: pointer;

      &:hover{
        background: #37AEFF;
        color: white;
      }
    }
  }
  .bg-mask{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BgSelect.vue